import { useMatch, useSearchParams } from "react-router-dom";
import { trackRoutesCombined } from "../TrackNavigation";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { trackState } from "../../../redux/track/trackSlice";
import { PageDefaultSegmentWithHeader } from "@sis/react-library";
import { Box, useTheme } from "@mui/material";
import { Loading } from "../../shared/Loading";
import { LoadingError } from "../../shared/LoadingError";
import { useEffect } from "react";
import { loadTrack } from "../../../redux/track/trackAction";
import { TrackFormWrapper } from "../trackForm/TrackFormWrapper";
import { getSearchCategory, getSearchProvider, updateSearchParamsForCategory, updateSearchParamsForProvider } from "../trackPage/trackPageHelper";
import { Track } from "../../../interfaces/dtos/track";
import { dispatchIsSuccessful, segmentHeaderDefault } from "../../../utils/commonUtils";
import { RppTitle } from "../../shared/RppTitle";

export const TrackEditPage = () => {

  const match = useMatch(trackRoutesCombined.editMatch);
  const theme = useTheme();
  const key = match?.params.key;

  const state = useAppSelector(trackState);
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const loadInformation = async () => {
    if (!key) { return; }
    const split = key.split("_");
    if (split.length !== 2) { return; }

    const provider = split[0];
    const trackCodeKey = split[1];
    const result = await dispatch(loadTrack(
      { provider, trackCodeKey }
    ));

    // If we have refreshed, or used a link with no search params, set the search params
    if (!dispatchIsSuccessful(result)) { return; }
    const payload = result.payload as Track[];
    if (!payload) { return; }
    const loadedTrack = payload.find((lt) => lt.key === key);
    if (!loadedTrack) { return; }
    const searchProvider = getSearchProvider(searchParams);
    const searchCategory = getSearchCategory(searchParams);
    if (!searchProvider || searchProvider !== loadedTrack.provider) {
      setSearchParams(updateSearchParamsForProvider(searchParams, loadedTrack.provider!));
    }
    if (!searchCategory || searchCategory !== loadedTrack.categoryCode) {
      setSearchParams(updateSearchParamsForCategory(searchParams, loadedTrack.categoryCode!));
    }
  }

  const track = state.tracks?.find((t) => t.key === key);

  useEffect(() => {
    if (key) {
      loadInformation();
    }
    // only use condition below
    // eslint-disable-next-line
  }, [key])

  return (
    <PageDefaultSegmentWithHeader
      headingText={`Edit: ${track ? track.sportCode : 'not found'}`}
      headingBackground={segmentHeaderDefault(theme)}
      headingColor={theme.palette.common.white}
      standardWidth
    >
      <RppTitle title={`Track Code: ${track ? track.sportCode : 'not found'}`} />
      {state.loadingItem &&
        <Box id="track-loading" sx={{ textAlign: 'center' }}><Loading /></Box>
      }
      {!state.loadingItem && !track &&
        <LoadingError id="track-notfound"> Could not load track {key}</LoadingError>
      }
      {!state.loadingItem && track &&
        <TrackFormWrapper track={track} />
      }
    </PageDefaultSegmentWithHeader>
  )
}
